import React from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility, FileCopy } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { encryptId } from "../../../Components/CryptoComponent";
import { useStaffLayout } from "../../../Components/Context/CandidateLayoutContext";

function RecruitmentProcedureList({ isAdmin }) {
  const navigate = useNavigate();

  const { privilegeData } = useStaffLayout();

  function hasRecProcAddprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName
        .toLowerCase()
        .includes("recruitment procedure");

      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "add" && priv.assigned == true
      );
    });
  }

  function hasRecProcEditprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName
        .toLowerCase()
        .includes("recruitment procedure");
      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "edit" && priv.assigned == true
      );
    });
  }

  function hasRecProcViewprivilege(privilegeData) {
    if (isAdmin) return true;
    return privilegeData.some((subModule) => {
      const isJob = subModule.subModuleName
        .toLowerCase()
        .includes("recruitment procedure");
      if (!isJob) return false;

      return subModule.privileges.some(
        (priv) =>
          priv.privilegeName.toLowerCase() === "view" && priv.assigned == true
      );
    });
  }

  const columns = [
    { field: "RP_Id", label: "#" },
    { field: "RP_Name", label: "Recruitment Procedure" },
  ];

  const [searchParams] = useSearchParams();

  const actions = [
    hasRecProcViewprivilege(privilegeData) && {
      icon: Visibility,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.RP_Id));
        navigate(
          `/RecruitmentProcedure/View/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "primary",
    },
    {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.RP_Id));
        navigate(
          `/RecruitmentProcedure/Edit/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "warning",
      tooltip: "Edit this Recruitment Procedure",
    },
    hasRecProcEditprivilege(privilegeData) && {
      icon: FileCopy,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.RP_Id));
        navigate(`/RecruitmentProcedure/Clone/${encrypted}?${searchParams.toString()}`);
      },
      // color: "success",
      tooltip: "Clone this Recruitment Procedure",
    },
  ].filter(Boolean);

  return (
    <DynamicTable
      columns={columns}
      // data={data}
      dataAPI={`/RecruitmentProcedure/list`}
      actions={actions}
      title={`Recruitment Procedure`}
      {...(hasRecProcAddprivilege(privilegeData) && {
        linkvalue: `/RecruitmentProcedure/Add?${searchParams.toString()}`,
      })}
    />
  );
}

export default RecruitmentProcedureList;
